import { capitalizeFirstLetter } from 'components/helper/helper';
import DatePickerInput from 'components/input/DatePicker';
import SelectInput from 'components/input/SelectInput';
import React from 'react';
import Grid from '@mui/joy/Grid';

interface Props {
  arrayName: { fieldName: string; dateName: string; label: string; options?: any[] }[];
  formik: any;
  disabled?: boolean;
  selectOptions: any[];
  isMobile?: boolean;
}

const ReuseFieldScoreAndDate = (props: Props) => {
  const { isMobile = false } = props;
  return (
    <Grid container spacing={isMobile ? 1 : 2}>
      {(props.arrayName || []).map((item, index) => {
        const labelScore = capitalizeFirstLetter(`Highest ${item.label} score*`);
        return (
          <React.Fragment key={index}>
            <Grid xs={6}>
              <SelectInput
                form={props.formik}
                disabled={props.disabled}
                option={item.options ?? props.selectOptions}
                label={labelScore}
                name={`${item.fieldName}`}
                values={props.formik.values[item.fieldName]}
                onChange={props.formik.handleChange}
              />
            </Grid>
            <Grid xs={6}>
              <DatePickerInput
                disabled={props.disabled}
                label="Date taken"
                name={`${item.dateName}`}
                values={props.formik.values[item.dateName]}
                onChange={(values) => props.formik.setFieldValue(item.dateName, values)}
              />
            </Grid>
          </React.Fragment>
        );
      })}
    </Grid>
  );
};

export default ReuseFieldScoreAndDate;
